import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDataQrApi,
  postPage,
  getVoucher,
  bookingTable,
  cancelBookingTable,
  getPaymentProvider,
  getFavorite,
  getFavoriteMenu,
  addFavorite,
  delFavorite,
  delFavoriteMenu,
} from "../action/page";

const initialState = {
  data: null,
  status: null,
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    [fetchDataQrApi.pending]: (state) => {
      state.data = null;
    },
    [fetchDataQrApi.fulfilled]: (state, payload) => {
      state.data = payload;
    },
    [fetchDataQrApi.rejected]: (state, payload) => {
      state.data = payload;
    },
    [postPage.pending]: (state) => {
      state.data = null;
    },
    [postPage.fulfilled]: (state, payload) => {
      state.data = payload;
    },
    [postPage.rejected]: (state, payload) => {
      state.data = payload;
    },
    [getVoucher.pending]: (state) => {
      state.data = null;
    },
    [getVoucher.fulfilled]: (state, payload) => {
      state.data = payload;
    },
    [getVoucher.rejected]: (state) => {
      state.data = null;
    },
    [getPaymentProvider.pending]: (state) => {
      state.data = null;
    },
    [getPaymentProvider.fulfilled]: (state, payload) => {
      state.data = payload;
    },
    [getPaymentProvider.rejected]: (state) => {
      state.data = null;
    },
    [bookingTable.pending]: (state) => {
      state.data = null;
    },
    [bookingTable.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [bookingTable.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [getFavorite.pending]: (state) => {
      state.data = null;
    },
    [getFavorite.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [getFavorite.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [getFavoriteMenu.pending]: (state) => {
      state.data = null;
    },
    [getFavoriteMenu.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [getFavoriteMenu.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [addFavorite.pending]: (state) => {
      state.data = null;
    },
    [addFavorite.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [addFavorite.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [delFavorite.pending]: (state) => {
      state.data = null;
    },
    [delFavorite.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [delFavorite.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [delFavoriteMenu.pending]: (state) => {
      state.data = null;
    },
    [delFavoriteMenu.fulfilled]: (state, payload) => {
      state.data = payload;
      state.status = "success";
    },
    [delFavoriteMenu.rejected]: (state) => {
      state.data = null;
      state.status = "rejected";
    },
    [cancelBookingTable.pending]: (state) => {
      state.data = null;
    },
    [cancelBookingTable.fulfilled]: (state, payload) => {
      state.data = payload;
    },
    [cancelBookingTable.rejected]: (state) => {
      state.data = null;
    },
  },
});

export default pageSlice;
